export enum CourseParticipationStatusModel {
    NoParticipation = 0,
    Started = 1,
    Completed = 2
}